import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { SummaryLayout } from "../../common/Layouts";
function SummaryTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const onFormLoad = useCallback(() => {
        props.summaryFormLoaded(formRefs);
    });
  const handleFieldChange = useCallback((name, value) => {
    });
    const handleSelectionChange = useCallback((name, e) => {
    }, []);

    return (
        <div className="FormMt">
            <FormField
            currrentUser={currentUser}
            layoutId='54D91028-8B69-43E1-9370-3A68A9153AD5'
            layoutName='SummaryForm'
            defaultFormSchema={SummaryLayout}
            formFields={props.formFields}
            setformFields={props.setformFields}
            onFormLoad={onFormLoad}
            handleFieldValueChange={handleFieldChange}
            handleSelectedItemChange={handleSelectionChange}
            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
            formRefs={formRefs}
        />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(SummaryTab);